// extracted by mini-css-extract-plugin
export var content = "_o7-1";
export var noScroll = "_o7-3";
export var paper = "_o7-0";
export var scrollable = "_o7-2";